export const AR = {
  "Open document": "Ø§ÙØªØ­ Ø§ÙÙØ³ØªÙØ¯",
  "Upload file": "Ø±ÙØ¹ ÙÙÙ",
  "Drop file here to upload": "ÙÙ Ø¨Ø¥Ø³ÙØ§Ø· Ø§ÙÙÙÙ ÙÙØ§ ÙÙØªØ­ÙÙÙ",
  "Disc": "ÙØ±Øµ",
  "URL": "URL",
  "FILE": "ÙÙÙ",
  "SIZE": "Ø¨Ø­Ø¬Ù",
  "MB": "ÙÙØºØ§ Ø¨Ø§ÙØª",
  "KB": "ÙÙÙÙ Ø¨Ø§ÙØª",
  "Bytes": "Ø¨Ø§ÙØª",
  "Loading... Please wait.": "Ø¬Ø§Ø±Ù Ø§ÙØªØ­ÙÙÙ Ø§ÙØªØ¸Ø± ÙÙ ÙØ¶ÙÙ.",
  "Fit Width": "Ø§ÙØ¹Ø±Ø¶ Ø§ÙÙÙØ§Ø³Ø¨",
  "Fit Height": "Ø§Ø±ØªÙØ§Ø¹ ÙÙØ§Ø¦Ù",
  "Password protected document": "ÙØ«ÙÙØ© ÙØ­ÙÙØ© Ø¨ÙÙÙØ© ÙØ±ÙØ±",
  "Password": "ÙÙÙÙ Ø§ÙØ³Ø±",
  "Open": "Ø§ÙØªØ­",
  "Password Required": "ÙÙÙØ© Ø§ÙÙØ±ÙØ± ÙØ·ÙÙØ¨Ø©",
  "Incorrect password": "ÙÙÙØ© Ø³Ø± Ø®Ø§Ø·Ø¦Ø©",
  "Error": "Ø®Ø·Ø£",
  "Something went wrong": "ÙÙØ§Ù Ø®Ø·Ø£ ÙØ§",
  "Server is not available": "Ø§ÙØ®Ø§Ø¯Ù ØºÙØ± ÙØªØ§Ø­",
  "of": "ÙÙ",
  "Please wait...": "Ø§Ø±Ø¬ÙÙ Ø§ÙØªØ¸Ø±..."
};
